enum ShopOrdersActions {
    FETCH_LIST = "shopOrdersFetchList",
    GET_ITEM = "shopOrdersGetItem",
    UPDATE_STATE = "shopOrdersUpdateState",
    UPDATE_COMMENT = "shopOrdersUpdateComment",
    REFRESH_LIST = "shopOrdersRefreshList",
    FETCH_STATES = "shopOrdersFetchStates",
    FETCH_STORAGES = "shopOrdersFetchStorages",
    CREATE_CREDIT = "shopOrdersCreateCredit",
    UPDATE_CREDIT = "shopOrdersUpdateCredit",
    DELETE_CREDIT = "shopOrdersDeleteCredit",
    SEND_EMAIL = "shopOrdersSendEmail",
    CREATE_LABEL = "shopOrdersCreateLabel",
    CREATE_AMAZON_LABEL = "shopOrdersCreateAmazonLabel",
    FETCH_EMAIL_TEMPLATES = "shopOrdersFetchEmailTemplates",
    SET_PAYMENT_REMINDER = "shopOrdersSetPaymentReminder",
    EXPORT = "shopOrdersExport",
    UPDATE_DELIVERY_ADDRESS = "shopOrdersUpdateDeliveryAddress",
    FETCH_COUNTRIES = "shopOrdersFetchCountries",
    SET_PAID = "shopOrdersSetPaid",
    // Phase 4 //
    QUICK_SEARCH = "shopOrdersQuickSearch",
    FETCH_SHIPPING_DASHBOARD = "shopOrdersFetchShippingDashboard",
    FETCH_ABANDONED_BASKETS = "shopOrdersFetchAbandonedBaskets",
    FETCH_PRINT_DOCUMENTS = "shopOrdersFetchPrintDocuments",
    FETCH_PRINT_DOCUMENT = "shopOrdersFetchPrintDocument",
}

enum ShopOrdersMutation {
    SET_RENDER_UPDATE = "shopOrdersListRenderNeeded",
    SET_LIST_RESULT = "shopOrdersListResult",
    SET_STATES = "shopOrdersSetStates",
    SET_STORAGES = "shopOrdersSetStorages",
    SET_EMAIL_TEMPLATES = "shopOrdersSetEmailTemplates",
    SET_COUNTRIES = "shopOrdersSetCountries",
    SET_SHIPPING_DASHBOARD = "shopOrdersSetShippingDashboard",
    SET_ABANDONED_BASKETS = "shopOrdersSetAbandonedBaskets",
}

export {ShopOrdersActions, ShopOrdersMutation};
